import React, { useState } from 'react';
import { View, Text, StyleSheet, ScrollView, TextInput, TouchableOpacity } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import type { StackNavigationProp } from '@react-navigation/stack';
import type { RootStackParamList } from '../types/navigation';
import { Icon } from '../components/Icon';
import { colors, spacing, fontWeights, borderRadius } from '../theme';

type NavigationProp = StackNavigationProp<RootStackParamList, 'M10SaveCustomerScreen'>;

export const M10SaveCustomerScreen: React.FC = () => {
  const navigation = useNavigation<NavigationProp>();
  const [phone, setPhone] = useState('0901 234 567');
  const [email, setEmail] = useState('nguyen.van.minh@example.com');
  const [address, setAddress] = useState('Quận 1, TP. Hồ Chí Minh');
  const [note, setNote] = useState('Khách hàng quan tâm gói đóng phí 20 năm, mục tiêu học vấn cho con.');

  const handleSave = () => {
    // Navigate back to Home
    navigation.navigate('M03HomeScreen');
  };

  return (
    <View style={styles.container}>
      <ScrollView contentContainerStyle={styles.scrollContent}>
        <View style={styles.cardHeader}>
          <Icon name="save" size={24} color={colors.secondary} />
          <Text style={styles.headerTitle}>Lưu thông tin khách hàng</Text>
          <Text style={styles.headerSub}>Bảng minh họa: Nguyễn Văn Minh - ManulifeMOVE</Text>
        </View>

        <View style={styles.formCard}>
          <View style={styles.inputContainer}>
            <Text style={styles.label}>Họ và tên khách hàng</Text>
            <TextInput style={[styles.input, styles.disabledInput]} value="Nguyễn Văn Minh" editable={false} />
          </View>

          <View style={styles.inputContainer}>
            <Text style={styles.label}>Số điện thoại *</Text>
            <TextInput style={styles.input} keyboardType="phone-pad" value={phone} onChangeText={setPhone} />
          </View>

          <View style={styles.inputContainer}>
            <Text style={styles.label}>Địa chỉ Email</Text>
            <TextInput style={styles.input} keyboardType="email-address" value={email} onChangeText={setEmail} />
          </View>

          <View style={styles.inputContainer}>
            <Text style={styles.label}>Địa chỉ tạm trú</Text>
            <TextInput style={styles.input} value={address} onChangeText={setAddress} />
          </View>

          <View style={styles.inputContainer}>
            <Text style={styles.label}>Ghi chú tư vấn</Text>
            <TextInput
              style={[styles.input, styles.textArea]}
              multiline
              numberOfLines={4}
              value={note}
              onChangeText={setNote}
            />
          </View>
        </View>

        {/* Action Buttons */}
        <View style={styles.actions}>
          <TouchableOpacity style={styles.backBtn} onPress={() => navigation.goBack()}>
            <Text style={styles.backBtnText}>Hủy bỏ</Text>
          </TouchableOpacity>
          <TouchableOpacity style={styles.saveBtn} onPress={handleSave}>
            <Text style={styles.saveBtnText}>LƯU THÔNG TIN</Text>
          </TouchableOpacity>
        </View>
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f5f7fa',
  },
  scrollContent: {
    padding: spacing[4],
    gap: spacing[4],
    paddingBottom: 40,
  },
  cardHeader: {
    backgroundColor: '#ffffff',
    padding: spacing[4],
    borderRadius: borderRadius.md,
    alignItems: 'center',
    borderWidth: 1,
    borderColor: colors.outlineVariant,
    gap: spacing[1],
  },
  headerTitle: {
    fontSize: 16,
    fontWeight: fontWeights.bold,
    color: colors.primary,
    marginTop: spacing[1],
  },
  headerSub: {
    fontSize: 12.5,
    color: colors.onSurfaceVariant,
  },
  formCard: {
    backgroundColor: '#ffffff',
    borderRadius: borderRadius.md,
    padding: spacing[4],
    borderWidth: 1,
    borderColor: colors.outlineVariant,
    gap: spacing[4],
  },
  inputContainer: {
    gap: spacing[1.5],
  },
  label: {
    fontSize: 13,
    fontWeight: fontWeights.semibold,
    color: colors.onSurface,
  },
  input: {
    backgroundColor: '#ffffff',
    borderWidth: 1,
    borderColor: colors.outline,
    borderRadius: borderRadius.DEFAULT,
    paddingHorizontal: spacing[3],
    height: 44,
    fontSize: 14,
    color: colors.onSurface,
  },
  disabledInput: {
    backgroundColor: colors.surface,
    color: colors.onSurfaceVariant,
    borderColor: colors.outlineVariant,
  },
  textArea: {
    height: 100,
    textAlignVertical: 'top',
    paddingTop: spacing[2],
  },
  actions: {
    flexDirection: 'row',
    gap: spacing[3],
    marginTop: spacing[2],
  },
  backBtn: {
    flex: 1,
    borderWidth: 1,
    borderColor: colors.primary,
    borderRadius: borderRadius.DEFAULT,
    height: 48,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#ffffff',
  },
  backBtnText: {
    fontSize: 14,
    fontWeight: fontWeights.bold,
    color: colors.primary,
  },
  saveBtn: {
    flex: 2,
    backgroundColor: colors.primary,
    borderRadius: borderRadius.DEFAULT,
    height: 48,
    alignItems: 'center',
    justifyContent: 'center',
  },
  saveBtnText: {
    color: '#ffffff',
    fontSize: 14,
    fontWeight: fontWeights.bold,
  },
});
